import React from 'react'

import styled from 'styled-components'

import { hslToHex } from '../../../../../utils/utils'

const Slider = ({
  id,
  value = 1,
  onChange,
  min,
  max,
  labels,
  containerWidth = 'auto',
}) => {
  const generateStatusColors = (statusList) => {
    const total = statusList.length

    return statusList.reduce((acc, status, index) => {
      const hue = (120 / (total - 1)) * index // red → green
      const lightness = 35 + (index / (total - 1)) * 30 // darker → brighter
      const background = hslToHex(hue, 100, lightness)

      acc[status] = {
        background,
        boxShadow: `0 0 4px ${background}`,
      }

      return acc
    }, {})
  }

  const status = Object.values(labels)

  const statusColors = generateStatusColors(status)

  return (
    <SliderContainer
      statusColors={statusColors}
      containerWidth={containerWidth}
    >
      <div className="slider">
        <span>{labels[value]}</span>
        <div>
          <input
            data-questionid={id}
            onChange={onChange}
            value={value}
            className={`slider ${labels[value].replace(/\s+/g, '')}`}
            type="range"
            min={min}
            max={max}
          />
        </div>
      </div>
    </SliderContainer>
  )
}

export default Slider

const SliderContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'statusColors',
})`
  height: 3.5rem;
  margin-bottom: 0.75rem;
  display: flex;
  justify-content: space-between;
  width: ${({ containerWidth }) => containerWidth};

  .slider {
    cursor: pointer;
    margin-right: 8px;
    width: 100%;
  }

  .slider span {
    font-size: 0.625rem;
    font-weight: 500;
    color: #acb2cc;
  }

  input[type='range'].slider {
    height: 2px;
    -webkit-appearance: none;
    outline: none;
    border: none;
    background: linear-gradient(
      90deg,
      #e4f79c -1.65%,
      #e4f79c -5.65%,
      #cae463 23.76%,
      #a2dd74 49.71%,
      #7dd585 76.18%,
      #5cca95 100%
    );
    border-radius: 100px;
    transition: all 0.3s ease-in-out;
  }

  input[type='range'].slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 0.875rem;
    height: 0.875rem;
    border-radius: 50%;

    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }

  /* Dynamic status styles */
  ${(props) =>
    props.statusColors &&
    Object.entries(props.statusColors)
      .map(
        ([status, color]) => `
        input[type='range'].slider.${status.replace(
          /\s+/g,
          ''
        )}::-webkit-slider-thumb {
          background: ${color.background};
          ${color.boxShadow ? `box-shadow: ${color.boxShadow};` : ''}
        }
        input[type='range'].slider.${status.replace(
          /\s+/g,
          ''
        )}::-moz-range-thumb {
          background: ${color.background};
          ${color.boxShadow ? `box-shadow: ${color.boxShadow};` : ''}
        }
        input[type='range'].slider.${status.replace(/\s+/g, '')}::-ms-thumb {
          background: ${color.background};
          ${color.boxShadow ? `box-shadow: ${color.boxShadow};` : ''}
        }
      `
      )
      .join('\n')}

  input[type='range'].slider:focus {
    outline: none;
  }
`
